












// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/family/edit/EditComposition.vue'
import ReadMembres from '@/components/compte/read/ReadMembres.vue'
import { getDefaultAloFamily, AloFamily } from '@/models/alo/AloFamily'
import { toStringDictionary } from '@/utils/groupBy';
import moment from 'moment';
import commande from '@/api/commande';
import { AloUser, getDefaultAloUser } from '@/models/alo/AloUser';

@Component({
  name: 'ReadComposition',    
   props: {
    family:{      
      default:getDefaultAloFamily()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit,ReadMembres}
})
export default class ReadComposition extends Vue {
  private family!:AloFamily
  private loading!:boolean


  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.family) }

}
